<template>
  <div id="app">
    <router-view />
    <ApiSelect/>
    <DomainSelect/>
  </div>
</template>

<script>
import ApiSelect from './components/ApiSelect.vue'
import DomainSelect from './components/DomainSelect.vue'
export default {
  name: 'App',
  components: {
    ApiSelect,
    DomainSelect
  },
  methods: {
  }
}
</script>

<style lang="less">
// @import './common/css/public.less';
@import './common/css/border.css';
@import './common/css/reset.css';
#app {
  // font-family: 'PingFang SC',Helvetica, Tahoma, Arial,'Hiragino Sans GB', 'Hiragino Sans GB W3', STXihei, STHeiti, SimHei, Heiti, SimSun, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/App.vue